import { Copy, SquareArrowOutUpRight, X } from 'lucide-react';
import { useFormContext, useWatch } from 'react-hook-form';
import { ControlledInput } from '@/components/controlled';
import { Button } from '@/components/ui';
import { Link } from 'react-router-dom';
import { notify } from '@/functions';

type TProps = {
  readonly?: boolean;
  index: number;
  name: string;
}

const FormContentCreateOrEditCreatorLinksItem = ({ index, name, readonly = false }: TProps) => {

  const { setValue, control } = useFormContext();
  const links = useWatch({ control, name }) as string[] ?? [];

  const inputName = `${name}[${index}]`;

  const handleOnClickBtnCopy = async () => {
    const link = [...links].filter((_, currentIndex) => currentIndex === index)[0];

    if (!link) {
      return;
    }

    // Copy to clipboard
    await navigator.clipboard.writeText(link);
    // Notify
    notify('Lien copié dans le presse-papier.');
  };

  const handleOnClickBtnRemove = () => {
    const newLinks = [...links].filter((_, currentIndex) => currentIndex !== index);
    setValue(name, newLinks);
  };

  return (
    <div className='flex'>
      <ControlledInput
        name={inputName}
        control={control}
        disabled={readonly}
        className='border-r-0 rounded-r-none focus-visible:ring-transparent'
        placeholder={`Lien N°${index + 1}`} />
      {
        links[index] &&
        <>
          <Link to={links[index]} target='_blank'>
            <Button
              className='border-l-0 rounded-l-none border-r-0 rounded-r-none px-3'
              title='Ouvrir directement le lien'
              variant={'outline'}>
              <SquareArrowOutUpRight size={16} />
            </Button>
          </Link>
          <Button
            className='border-l-0 rounded-l-none border-r-0 rounded-r-none px-3'
            onClick={handleOnClickBtnCopy}
            title='Copier le lien'
            variant={'outline'}>
            <Copy size={16} />
          </Button>
        </>
      }
      {
        !readonly &&
        <Button
          className='border-l-0 rounded-l-none px-3'
          onClick={handleOnClickBtnRemove}
          title='Supprimer le lien'
          variant={'outline'}>
          <X size={16} />
        </Button>
      }
    </div>
  );

};

export default FormContentCreateOrEditCreatorLinksItem;
